import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import HeroVideo from "../components/hero-video"
import Video from "../components/video"
import SliderGallery from "../components/slider-gallery"
import Aziende from "../components/aziende"
import RassegnaStampa from "../components/rassegna-stampa"
import Newsletter from "../components/newsletter"


const IndexPage = ({ pageContext: { locale } }) => {
  return (
    <Layout locale={locale}>
      <SEO bodyClass="header-testata" />
      <HeroVideo />
      <div className="gradiente">
        <Video />
        <SliderGallery />
        <Aziende />
        <RassegnaStampa featured={true} />
        <Newsletter />
      </div>
    </Layout>
  )
};

export default IndexPage;
